module.exports = __webpack_public_path__ + "img/3.932882d2.png";